<template>
	<div class="container pb_0">
		<div class="main type_01">
			<p class="text_t type1">
				{{ $t('rtr_personal-asset-exchange.title1') }}
			</p>
			<p class="text_n">
				{{ $t('rtr_personal-asset-exchange.text1') }}<br />
				{{ $t('rtr_personal-asset-exchange.text2') }}
			</p>
			<div class="button_area">
				<button class="button_bg_red mr_10" @click="toLogin">
					{{ $t('button.signup') }}
				</button>
				<button class="button_bg_black" @click="notYet">
					{{ $t('button.down') }}
				</button>
			</div>
		</div>
		<div class="bottom_area_wrap">
			<div class="bottom_area">
				<div class="bg_box mb_16">
					<div class="bg_text_area pt_100">
						<p class="text_t type2 tac">
							{{ $t('rtr_personal-asset-exchange.title2') }}<br />
						</p>
						<p class="text_n tac">
							{{ $t('rtr_personal-asset-exchange.text3') }}<br />{{
								$t('rtr_personal-asset-exchange.text4')
							}}
						</p>
					</div>
				</div>
				<div class="bg_box mb_16">
					<div class="bg_text_area left">
						<p class="text_t fc_white tac">
							{{ $t('rtr_personal-asset-exchange.title3') }}<br />
							{{ $t('rtr_personal-asset-exchange.title4') }}
						</p>
						<p class="text_n fc_white tac">
							{{ $t('rtr_personal-asset-exchange.text5') }}<br />
							{{ $t('rtr_personal-asset-exchange.text6') }}
						</p>
					</div>
				</div>

				<div class="bg_box bg_white">
					<div class="bg_text_area right tac">
						<p class="text_t mb_30">
							{{ $t('rtr_personal-asset-exchange.title5') }}
						</p>
						<p class="text_n">
							{{ $t('rtr_personal-asset-exchange.text7') }}<br />
							{{ $t('rtr_personal-asset-exchange.text8') }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Exchange.vue',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
		toLogin() {
			this.$router.push({ name: 'auth-login' });
		},
	},
};
</script>
